<template>
  <fragment>
    <v-card-text class="nuclear-content">
      <v-container id="profile">
        <v-row justify="space-between">
          <v-col cols="12" md="6" class="my">
            <v-card flat="flat" class="card">
              <v-card-title>
                My Profile
                <font-awesome-icon class="down-arrow" icon="chevron-down" />
              </v-card-title>
              <v-card-text>
                <v-row class="introduction">
                  <v-col cols="12" sm="4" md="5" lg="5" class="profile-image">
                    <v-avatar class="myprofile" color="grey" tile>
                      <v-img src="/assets/images/myprofile.png"></v-img>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" sm="8" md="7" lg="7" class="profile-info">
                    <v-row>
                      <v-col cols="12" sm="4" md="6" lg="4">
                        <span class="pointer">Full Name</span>
                      </v-col>
                      <v-col cols="12" sm="8" md="6" lg="8">
                        <span v-if="this.showeditprofilepage == false">{{
                          profile.fullname
                        }}</span>
                        <v-text-field
                          v-model="profile.fullname"
                          :rules="fieldRules"
                          required
                          v-else
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="4" md="6" lg="4">
                        <span class="pointer">Title</span>
                      </v-col>
                      <v-col cols="12" sm="8" md="6" lg="8">
                        <span v-if="this.showeditprofilepage == false">{{
                          profile.title
                        }}</span>
                        <v-text-field
                          v-model="profile.title"
                          :rules="fieldRules"
                          required
                          v-else
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="4" md="6" lg="4">
                        <span class="pointer">Company</span>
                      </v-col>
                      <v-col cols="12" sm="8" md="6" lg="8">
                        <span v-if="this.showeditprofilepage == false">{{
                          profile.company.name
                        }}</span>
                        <v-text-field
                          v-model="profile.company.name"
                          :rules="fieldRules"
                          required
                          v-else
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="4" md="6" lg="4">
                        <span class="pointer">Username</span>
                      </v-col>
                      <v-col cols="12" sm="8" md="6" lg="8">
                        <span v-if="this.showeditprofilepage == false">{{
                          profile.username
                        }}</span>
                        <v-text-field
                          v-model="profile.username"
                          :rules="fieldRules"
                          required
                          v-else
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="gender">
                      <v-col cols="12" sm="4" md="6" lg="4">
                        <span class="pointer">Gender</span>
                      </v-col>
                      <v-col cols="12" sm="8" md="6" lg="8">
                        <span
                          v-if="
                            this.showeditprofilepage == false &&
                              profile.gender == 0
                          "
                          >Male</span
                        >
                        <span
                          v-if="
                            this.showeditprofilepage == false &&
                              profile.gender == 1
                          "
                          >Female</span
                        >
                        <span
                          v-if="
                            this.showeditprofilepage == false &&
                              profile.gender == 2
                          "
                          >Unspecified</span
                        >
                        <v-radio-group
                          v-model="profile.gender"
                          row
                          class="d-flex justify-content-sm-between"
                          v-else-if="this.showeditprofilepage == true"
                        >
                          <v-radio
                            label="Male"
                            :value="0"
                            color="#5f6f85"
                          ></v-radio>
                          <v-radio
                            label="Female"
                            :value="1"
                            color="#5f6f85"
                          ></v-radio>
                          <v-radio
                            label="Unspecified"
                            :value="2"
                            color="#5f6f85"
                          ></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="address">
                  <div class="header-divider">
                    <span>Address Info</span>
                    <v-divider class="mx-3"></v-divider>
                  </div>
                  <v-row>
                    <v-col cols="12" sm="2" md="3" lg="2">
                      <span class="pointer">Address</span>
                    </v-col>
                    <v-col cols="12" sm="10" md="9" lg="10">
                      <span v-if="this.showeditprofilepage == false">{{
                        profile.address
                      }}</span>
                      <v-text-field
                        v-model="profile.address"
                        :rules="fieldRules"
                        required
                        v-else
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="2" md="3" lg="2">
                      <span class="pointer">Country</span>
                    </v-col>
                    <v-col cols="12" sm="10" md="9" lg="10">
                      <span v-if="this.showeditprofilepage == false">{{
                        profile.country.name
                      }}</span>
                      <v-autocomplete
                        v-model="profile.country"
                        :rules="fieldRules"
                        :items="countries"
                        single-line
                        item-text="name"
                        item-value="id"
                        return-object
                        required
                        v-else
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="2" md="3" lg="2">
                      <span class="pointer">Language</span>
                    </v-col>
                    <v-col cols="12" sm="10" md="9" lg="10">
                      <span v-if="this.showeditprofilepage == false">{{
                        profile.language.name
                      }}</span>
                      <v-autocomplete
                        v-model="profile.language"
                        :rules="fieldRules"
                        :items="languageOptions"
                        item-text="name"
                        item-value="id"
                        required
                        return-object
                        v-else
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="2" md="3" lg="2">
                      <span class="pointer">Time Zone</span>
                    </v-col>
                    <v-col cols="12" sm="10" md="9" lg="10">
                      <span v-if="this.showeditprofilepage == false">{{
                        profile.timezone.name
                      }}</span>
                      <v-autocomplete
                        v-model="profile.timezone"
                        :rules="fieldRules"
                        :items="timezoneOptions"
                        item-text="name"
                        item-value="id"
                        return-object
                        required
                        v-else
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="2" md="3" lg="2">
                      <span class="pointer">Email</span>
                    </v-col>
                    <v-col cols="12" sm="10" md="9" lg="10">
                      <span v-if="this.showeditprofilepage == false">{{
                        profile.email
                      }}</span>
                      <v-text-field
                        v-model="profile.email"
                        :rules="fieldRules"
                        type="email"
                        required
                        v-else
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="pointer" cols="12" sm="2" md="3" lg="2">
                      <span class="pointer">Phone</span>
                    </v-col>
                    <v-col cols="12" sm="10" md="9" lg="10">
                      <span v-if="this.showeditprofilepage == false">{{
                        profile.phone_number
                      }}</span>
                      <v-text-field
                        v-model="profile.phone_number"
                        :rules="fieldRules"
                        type="text"
                        v-mask="'(###) ###-####'"
                        required
                        v-else
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <div class="password">
                  <div class="header-divider">
                    <span>Password</span>
                    <v-divider class="mx-3"></v-divider>
                  </div>
                  <v-row>
                    <v-dialog
                      v-model="passworddialog"
                      persistent
                      max-width="600px"
                    >
                      <template v-slot:activator="{ on }">
                        <span v-on="on" class="change">Change password</span>
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline">Change Password</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-form
                              v-model="changePwdFormValid"
                              ref="changePwdForm"
                              lazy-validation
                            >
                              <v-text-field
                                v-model="currentpassword"
                                label="Current Password"
                                type="password"
                                :rules="passwordRules"
                                required
                              ></v-text-field>

                              <v-text-field
                                v-model="password"
                                label="New Password"
                                type="password"
                                :rules="passwordRules"
                                required
                              ></v-text-field>

                              <v-text-field
                                v-model="passwordConfirm"
                                label="Confirm New Password"
                                type="password"
                                :rules="passwordRules"
                                required
                              ></v-text-field>

                              <div class="mt-5">
                                <p
                                  style="color: red"
                                  v-if="passwordChangeStatus.status == -1"
                                >
                                  {{ passwordChangeStatus.text }}
                                </p>
                                <p
                                  style="color: #2bb9aa"
                                  v-if="passwordChangeStatus.status == 1"
                                >
                                  {{ passwordChangeStatus.text }}
                                </p>
                              </div>
                            </v-form>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="passworddialog = false"
                            >Close</v-btn
                          >
                          <v-btn
                            color="blue darken-1"
                            text
                            @click="changePassword"
                            >Save</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6" class="company">
            <v-card flat="flat" class="card">
              <v-card-title>
                Company Profile
                <font-awesome-icon class="down-arrow" icon="chevron-down" />
              </v-card-title>
              <v-card-text>
                <v-row class="introduction">
                  <v-col cols="12" sm="4" md="5" lg="5" class="profile-image">
                    <v-avatar class="myprofile" color="grey" tile>
                      <v-img src="/assets/images/myprofile.png"></v-img>
                    </v-avatar>
                  </v-col>
                  <v-col cols="12" sm="8" md="7" lg="7" class="profile-info">
                    <v-row>
                      <v-col cols="12" sm="4" md="6" lg="6">
                        <span class="pointer">Company Name</span>
                      </v-col>
                      <v-col cols="12" sm="8" md="6" lg="6">
                        <span v-if="this.showeditprofilepage == false">{{
                          profile.company.name
                        }}</span>
                        <v-text-field
                          v-model="profile.company.name"
                          :rules="fieldRules"
                          required
                          v-else
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="4" md="6" lg="6">
                        <span class="pointer">Established</span>
                      </v-col>
                      <v-col cols="12" sm="8" md="6" lg="6">
                        <span v-if="this.showeditprofilepage == false">{{
                          profile.company.establish
                        }}</span>
                        <v-text-field
                          v-model="profile.company.establish"
                          type="date"
                          v-mask="'####-##-##'"
                          v-else
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="4" md="6" lg="6">
                        <span class="pointer">Company URL</span>
                      </v-col>
                      <v-col cols="12" sm="8" md="6" lg="6">
                        <span v-if="this.showeditprofilepage == false">{{
                          profile.company.website
                        }}</span>
                        <v-text-field
                          v-model="profile.company.website"
                          :rules="fieldRules"
                          required
                          v-else
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="4" md="6" lg="6">
                        <span class="pointer">Company Contact</span>
                      </v-col>
                      <v-col cols="12" sm="8" md="6" lg="6">
                        <span v-if="this.showeditprofilepage == false">{{
                          profile.company.owner
                        }}</span>
                        <v-text-field
                          v-model="profile.company.owner"
                          :rules="fieldRules"
                          required
                          v-else
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <div class="address">
                  <div class="header-divider">
                    <span>Address Info</span>
                    <v-divider class="mx-3"></v-divider>
                  </div>
                  <v-row>
                    <v-col cols="12" sm="2" md="3" lg="2">
                      <span class="pointer">Address</span>
                    </v-col>
                    <v-col cols="12" sm="10" md="9" lg="10">
                      <span v-if="this.showeditprofilepage == false">{{
                        profile.company.address
                      }}</span>
                      <v-text-field
                        v-model="profile.company.address"
                        :rules="fieldRules"
                        required
                        v-else
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="2" md="3" lg="2">
                      <span class="pointer">Country</span>
                    </v-col>
                    <v-col cols="12" sm="10" md="9" lg="10">
                      <span v-if="this.showeditprofilepage == false">{{
                        profile.company.country.name
                      }}</span>
                      <v-autocomplete
                        v-model="profile.company.country"
                        :rules="fieldRules"
                        :items="countries"
                        item-text="name"
                        item-value="id"
                        return-object
                        required
                        v-else
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="2" md="3" lg="2">
                      <span class="pointer">Language</span>
                    </v-col>
                    <v-col cols="12" sm="10" md="9" lg="10">
                      <span v-if="this.showeditprofilepage == false">{{
                        profile.company.language.name
                      }}</span>
                      <v-autocomplete
                        v-model="profile.company.language"
                        :rules="fieldRules"
                        :items="languageOptions"
                        item-text="name"
                        item-value="id"
                        return-object
                        required
                        v-else
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="2" md="3" lg="2">
                      <span class="pointer">Time Zone</span>
                    </v-col>
                    <v-col cols="12" sm="10" md="9" lg="10">
                      <span v-if="this.showeditprofilepage == false">{{
                        profile.company.timezone.name
                      }}</span>
                      <v-autocomplete
                        v-model="profile.company.timezone"
                        :rules="fieldRules"
                        :items="timezoneOptions"
                        item-text="name"
                        item-value="id"
                        return-object
                        required
                        v-else
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="2" md="3" lg="2">
                      <span class="pointer">Email</span>
                    </v-col>
                    <v-col cols="12" sm="10" md="9" lg="10">
                      <span v-if="this.showeditprofilepage == false">{{
                        profile.company.email
                      }}</span>
                      <v-text-field
                        v-model="profile.company.email"
                        :rules="fieldRules"
                        required
                        v-else
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="2" md="3" lg="2">
                      <span class="pointer">Phone</span>
                    </v-col>
                    <v-col cols="12" sm="10" md="9" lg="10">
                      <span v-if="this.showeditprofilepage == false">{{
                        profile.company.phone
                      }}</span>
                      <v-text-field
                        v-model="profile.company.phone"
                        :rules="fieldRules"
                        type="text"
                        v-mask="'(###) ###-####'"
                        required
                        v-else
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions class="footer" v-if="this.showeditprofilepage == true">
      <v-btn class="commit" color="#2bb9aa" @click="updateProfile"
        >COMMIT</v-btn
      >
      <v-btn class="discard" color="white" @click="discardEdit">DISCARD</v-btn>
    </v-card-actions>
    <v-card-actions class="footer" v-if="this.showeditprofilepage == false">
      <v-btn class="commit" color="#2bb9aa" @click="ShowEditPage">EDIT</v-btn>
    </v-card-actions>
  </fragment>
</template>

<script>
export default {
  data() {
    return {
      showeditprofilepage: false,

      fieldRules: [v => !!v || "Required"],
      passwordRules: [
        v => !!v || "This field is Required",
        v =>
          /(?=.*[a-z])/.test(v) ||
          "Must contain at least 1 lowercase alphabetical character",
        v =>
          /(?=.*[A-Z])/.test(v) ||
          "Must contain at least 1 uppercase alphabetical character",
        v =>
          /(?=.*[0-9])/.test(v) || "Must contain at least 1 numeric character",
        v =>
          /(?=.[!@#\$%\^&])/.test(v) ||
          "Must contain at least one special character",
        v => /(?=.{8,})/.test(v) || "Must be eight characters or longer"
      ],

      passworddialog: false,
      changePwdFormValid: false,

      currentpassword: "",
      password: "",
      passwordConfirm: ""
    };
  },
  computed: {
    profile() {
      return this.$store.state.user.profile;
    },
    timezoneOptions() {
      return this.$store.getters.timezones;
    },
    languageOptions() {
      return this.$store.getters.languages;
    },
    countries() {
      return this.$store.getters.countries;
    },
    passwordChangeStatus() {
      return this.$store.state.user.passwordChangeStatus;
    }
  },

  methods: {
    ShowEditPage() {
      this.showeditprofilepage = !this.showeditprofilepage;
    },

    changePassword() {
      if (!this.$refs.changePwdForm.validate()) {
        return;
      }
      if (this.password != this.passwordConfirm) {
        this.$store.dispatch("passwordNotMatch");
        return;
      }

      const data = {
        old_password: this.currentpassword,
        new_password: this.password
      };

      this.$store
        .dispatch("changePassword", data)
        .then(() => {})
        .catch(error => {
        });
    },

    discardEdit() {
      this.$store.dispatch("discardProfile");
      this.showeditprofilepage = false;
    },

    updateProfile() {
      let profile = {
        fullname: this.profile.fullname,
        username: this.profile.username,
        gender: this.profile.gender,
        address: this.profile.address,
        country: this.profile.country.id,
        language: this.profile.language.id,
        timezone: this.profile.timezone.id,
        title: this.profile.title,
        company: {
          name: this.profile.company.name,
          establish: this.profile.company.establish,
          website: this.profile.company.website,
          owner: this.profile.company.owner,
          address: this.profile.company.address,
          country: this.profile.company.country.id,
          language: this.profile.company.language.id,
          timezone: this.profile.company.timezone.id,
          email: this.profile.company.email,
          phone: this.profile.company.phone
        }
      };

      this.$store
        .dispatch("updateProfile", profile)
        .then(() => {
          this.showeditprofilepage = false;
        })
        .catch(error => {
        });
    }
  }
};
</script>
